import { SuperAdminHomeLinkCards } from "src/components/superadmin/SuperAdminHomeLinkCards"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"

export const SuperAdminHome = () => {
 
    const userName = useAppState(state=>state.user_name)

    return (
        <PageLayout
            header={<PageHeader
                title={`Welcome ${userName}`}
            />
        }>
            <SuperAdminHomeLinkCards/>
        </PageLayout>
    )
} 